import { useState, useEffect } from 'react'

// Responsive breakpoints
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
}

// Hook to detect screen size
export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const media = window.matchMedia(query)
    if (media.matches !== matches) {
      setMatches(media.matches)
    }
    
    const listener = () => setMatches(media.matches)
    media.addEventListener('change', listener)
    
    return () => media.removeEventListener('change', listener)
  }, [matches, query])

  return matches
}

// Utility to check if mobile device (prioritize user agent for actual mobile devices)
export const isMobileDevice = () => {
  // First check if it's an actual mobile device by user agent
  const mobileUserAgent = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  
  // If it's a mobile device, return true regardless of screen size
  if (mobileUserAgent) return true
  
  // If it's NOT a mobile device (desktop/laptop), check screen width
  // Return true only if width is less than md breakpoint (768px)
  return window.innerWidth < breakpoints.md
}

// Utility to check if tablet
export const isTablet = () => window.innerWidth >= breakpoints.md && window.innerWidth < breakpoints.lg

// Utility to check if desktop
export const isDesktop = () => window.innerWidth >= breakpoints.lg